import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AssistantConnection } from '@core/models/assistant/assistant.model';

import { SelectItem, SelectValue } from '@shared/components/select/select-item.model';
import { SelectComponent } from '@shared/components/select/select.component';

@Component({
  selector: 'app-assistant-settings',
  imports: [SelectComponent, TranslatePipe],
  template: `
    <div class="border-weak bg-surface flex flex-col gap-2 border-b p-3">
      <label class="form-label mb-0 text-xs" for="assistant-connection">{{
        'assistant.settings.connection' | translate
      }}</label>
      <app-select
        id="assistant-connection"
        [items]="connectionItems()"
        [value]="connectionId()"
        (valueChange)="onConnection($event)" />
      <label class="form-label mb-0 text-xs" for="assistant-model">{{
        'assistant.settings.model' | translate
      }}</label>
      <app-select
        id="assistant-model"
        [items]="modelItems()"
        [value]="model()"
        (valueChange)="onModel($event)" />
      @if (selected()?.source === 'user') {
        <label class="form-label mb-0 text-xs" for="assistant-key">{{
          'assistant.settings.api_key' | translate
        }}</label>
        <input
          id="assistant-key"
          class="form-input font-mono"
          type="password"
          autocomplete="off"
          spellcheck="false"
          [value]="apiKey()"
          (input)="apiKeyChange.emit($any($event.target).value)" />
        <p class="form-help mt-0">{{ 'assistant.settings.api_key_help' | translate }}</p>
      }
    </div>
  `,
  styles: ``
})
export class AssistantSettingsComponent {
  readonly connections = input.required<AssistantConnection[]>();
  readonly connectionId = input<string | null>(null);
  readonly model = input<string | null>(null);
  readonly apiKey = input('');
  readonly connectionChange = output<string>();
  readonly modelChange = output<string>();
  readonly apiKeyChange = output<string>();

  protected readonly selected = computed(
    () => this.connections().find((c) => c.id === this.connectionId()) ?? null
  );
  protected readonly connectionItems = computed<SelectItem[]>(() =>
    this.connections().map((c) => ({ id: c.id, label: c.label }))
  );
  protected readonly modelItems = computed<SelectItem[]>(() =>
    (this.selected()?.models ?? []).map((m) => ({ id: m, label: m }))
  );

  protected onConnection(value: SelectValue): void {
    if (typeof value === 'string') this.connectionChange.emit(value);
  }

  protected onModel(value: SelectValue): void {
    if (typeof value === 'string') this.modelChange.emit(value);
  }
}
